import Aos from "aos"
import whenDomReady from "when-dom-ready"
import Swiper, { Navigation, Pagination } from 'swiper'

require('./bootstrap');

require('../_ex/js-toggle/index')


whenDomReady(() => {
    //init AOS
    Aos.init()

    //message float
    messageFloat()
    window.addEventListener('scroll', messageFloat)
    function messageFloat() {
        if (window.scrollY >= (window.innerHeight + 160)) {
            document.querySelector('body').classList.add('float-message--show');
        } else {
            document.querySelector('body').classList.remove('float-message--show');
        }
    }

    let featuredWorks = document.querySelector('#featured-works')
    if (featuredWorks != null) {
        const homeSwiper = new Swiper(featuredWorks, {
            modules: [Navigation, Pagination],
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    let whatWeDo = document.querySelector('#what-we-do')
    if (whatWeDo != null) {
        const homeSwiper = new Swiper(whatWeDo, {
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    }

    document.querySelectorAll('.btn-service-collapse').forEach(function (el) {
        el.addEventListener('click', function (event) {
            let target = this
            let collapsed = target.classList.contains('collapsed')
            let parentId = target.dataset.parent

            //collapsed = tertutup
            if (collapsed) {
                document.querySelector(parentId).classList.remove('show')
            } else {
                document.querySelector(parentId).classList.add('show')
            }

        })
    })

    //animasi client
    document.querySelectorAll('.client-item').forEach(function (el) {
        let random = parseInt(Math.random() * 3000)
        let interval = 4000 + random
        setTimeout(setShow2, interval, el.id);
    })

    function setShow2(id) {
        document.getElementById(id).classList.add('show--2')
        let random = parseInt(Math.random() * 3000)
        let interval = 4000 + random

        setTimeout(removeShow2, interval, id);
    }

    function removeShow2(id) {
        let random = parseInt(Math.random() * 3000)
        let interval = 4000 + random
        document.getElementById(id).classList.remove('show--2')

        setTimeout(setShow2, interval, id);
    }
})
